// @flow
import { forEach, orderBy, toLower } from 'lodash';
import { type Card } from './types';

export const sortWatchlistByName = (
  items: Array<Card>,
  ascendingOrder: boolean = true,
): Array<Card> =>
  orderBy([...items], [(card: Card) => toLower(card.name)], [ascendingOrder ? 'asc' : 'desc']);

export const sortWatchListByDateAdded = (
  items: Array<Card>,
  descendingOrder: boolean = true,
): Array<Card> => orderBy([...items], ['createdTime'], [descendingOrder ? 'desc' : 'asc']);

export const populateContentIdsSet = (
  cards: Array<Card>,
  existingMapping: { [key: number]: boolean },
): { [key: number]: boolean } => {
  const set = { ...existingMapping };

  forEach(cards, card => {
    // eslint-disable-next-line camelcase
    if (card.content_identification?.content_id) {
      set[card.content_identification.content_id] = true;
    }
  });

  return set;
};

export const filterOutRemovedWatchlistItem = (content: Array<Card>, deletedContentId: number) =>
  content.filter((card: Card) => card.content_identification?.content_id !== deletedContentId);
